function CollectionGridFactory(container) {
  class CollectionGrid {
    constructor(container) {
      this.collectionGrid = container;
      this._setListModeEvents();
    }

    _setListModeEvents() {
      const modeItems = this.collectionGrid.querySelectorAll(
        "[data-toggle-list-mode]"
      );
      const collectionSection = document.querySelector(
        ".shopify-section--main-collection, .shopify-section--main-search, .shopify-section--main-search-results"
      );

      for (const item of modeItems) {
        item.addEventListener("click", () => {
          // Remove --active from all siblings
          modeItems.forEach((el) => el.classList.remove("--active"));

          // Add --active to clicked one
          item.classList.add("--active");

          // Set list-mode attribute on main collection section
          const mode = item.getAttribute("data-toggle-list-mode");

          if (collectionSection) {
            collectionSection.setAttribute("list-mode", mode);
            collectionSection.classList.toggle(`list-mode--${mode}`);
          }
        });
      }
    }
  }

  return new CollectionGrid(container);
}
